import { render } from "./SpecialLectureList.vue?vue&type=template&id=5cac3e8a"
import script from "./SpecialLectureList.vue?vue&type=script&lang=js"
export * from "./SpecialLectureList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__